import { render, staticRenderFns } from "./BroadFileAnswer.vue?vue&type=template&id=65ef0c70&scoped=true&"
import script from "./BroadFileAnswer.vue?vue&type=script&lang=ts&"
export * from "./BroadFileAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./BroadFileAnswer.vue?vue&type=style&index=0&id=65ef0c70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ef0c70",
  null
  
)

export default component.exports